<template>
  <LsInfoCard
    v-if="displayedMessage != null"
    :track-id="validatedOrigin"
    test-id="balance_will_be_processed_notice"
  >
    <div>
      <h4>BALANCE WILL BE PROCESSED</h4>
      <p>Your outstanding balance for completed services is {{ displayedMessage }}</p>
    </div>
  </LsInfoCard>
</template>

<script>
import { LsInfoCard } from '@/components/common';
import VueTypes from 'vue-types';
import _ from 'lodash';
import { currency } from 'ls-vue-common/src/filters/currency';

export default {
  name: 'LsBalanceWillBeProcessedNotice',
  components: { LsInfoCard },
  props: {
    origin: VueTypes.string,
    balance: VueTypes.number.def(0),
  },
  computed: {
    validatedOrigin() {
      const originVal = _.isEmpty(this.origin) ? 'component' : this.origin;
      return originVal + '-balance_will_be_processed_notice';
    },
    validatedBalance() {
      return currency({
        amount: this.balance > 0 ? 0 : Math.abs(this.balance),
        emptyDisplay: '$0.00',
      });
    },
    displayedMessage() {
      if (this.validatedBalance === '$0.00') return null;
      return `${this.validatedBalance} which will be charged to your updated payment method.`;
    },
  },
};
</script>

<style lang="scss" scoped>
.info-card {
  margin: 1rem 0 3rem 0;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 2rem 2rem 4rem;

  &.no-margin-top {
    margin-top: 0 !important;
  }

  h4 {
    font-weight: 700;
    margin-bottom: 2px;
    text-transform: uppercase;
  }

  p {
    line-height: 1.5;
  }
}
</style>
